// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetByUserIdRequestModel from '../../model/get-by-user-id-request-model';
import GetByUserIdRequestDTO from '../dto/get-by-user-id-request-dto';
import dtoSchema from '../schemas/get-by-user-id-request-schema';

export default abstract class GetByUserIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetByUserIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;

  static toModel(dto: DeepPartial<GetByUserIdRequestDTO>): GetByUserIdRequestModel;
  static toModel(dto: DeepPartial<GetByUserIdRequestDTO> | undefined | null): GetByUserIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetByUserIdRequestDTO> | undefined | null): GetByUserIdRequestModel | undefined {
    return dto ? new GetByUserIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetByUserIdRequestModel> | GetByUserIdRequestModel): GetByUserIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetByUserIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetByUserIdRequestModel, can not map to GetByUserIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
